// extracted by mini-css-extract-plugin
export default {"root":"ViewMiscellaneousButton_root__C9jkU"};